import { defineStore } from 'pinia'
import { getCenterTimezoneOptions } from '@/services/businessMasterData'
import type { CenterTimezoneOption } from '@/types/businessCenter'

export const DEFAULT_ADMIN_TIMEZONE = 'UTC+8'

let timezoneOptionsRequest: Promise<CenterTimezoneOption[]> | null = null

export const useTimezoneStore = defineStore('timezone', {
  state: () => ({
    options: [] as CenterTimezoneOption[],
    currentTimezone: DEFAULT_ADMIN_TIMEZONE,
    loaded: false,
    loading: false
  }),
  getters: {
    currentDisplayName: state =>
      state.options.find(item => item.timezoneId === state.currentTimezone)?.displayName || state.currentTimezone
  },
  actions: {
    async fetchOptions(force = false) {
      if (!force && this.loaded) return this.options
      if (!force && timezoneOptionsRequest) return timezoneOptionsRequest

      this.loading = true
      timezoneOptionsRequest = getCenterTimezoneOptions()
      try {
        const options = await timezoneOptionsRequest
        this.options = options
        this.loaded = true
        if (!options.some(item => item.timezoneId === this.currentTimezone)) {
          this.currentTimezone =
            options.find(item => item.timezoneId === DEFAULT_ADMIN_TIMEZONE)?.timezoneId ||
            options[0]?.timezoneId ||
            DEFAULT_ADMIN_TIMEZONE
        }
        return options
      } finally {
        this.loading = false
        timezoneOptionsRequest = null
      }
    },
    selectTimezone(timezoneId: string) {
      if (this.loaded && !this.options.some(item => item.timezoneId === timezoneId)) return false
      this.currentTimezone = timezoneId
      return true
    }
  },
  persist: {
    pick: ['currentTimezone']
  }
})
